import { SchemaUtil } from '../utils/schema.util';
import { ColumnMapVisitor } from './columnMap.visitor';
import { SinkPlainObject } from '../plainObjects/sink.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class SinkVisitor extends ColumnMapVisitor {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitInputDefinition(inputDefinitionContext: any): void {
        (this.transformation as SinkPlainObject).columns = SchemaUtil.getSchemaFromInputOutputDefinition(inputDefinitionContext);
    }
}
